import API_BASE_URL from '../Config';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getConfiguracionEntidad = async () => {
    const response = await fetch(`${API_BASE_URL}/configuracion-entidad`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al obtener configuración de entidad');
    return response.json();
};

export const updateConfiguracionEntidad = async (data) => {
    const response = await fetch(`${API_BASE_URL}/configuracion-entidad`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar configuración de entidad');
    return response.json();
};
